/**
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 **/

import { css } from 'styled-components';
import Colors from '@userzoomlibraries/toolkit-themes-userzoom-platform-globals/colors';
import Button from '@userzoomlibraries/toolkit-button';

import { UiBreakpoint } from '../../../../utils/constants';

const InstallAppStyles = css`
	text-align: center;
	display: flex;
	flex-direction: column;
	height: 100vh;

	&.landscape {
		.container {
			max-width: 100%;

			.cards {
				flex-direction: row;
				margin-bottom: 20px;

				.card {
					flex: 1;
					margin: 0 8px;
					height: 100%;
				}
			}
		}
	}

	.shape {
		position: absolute;
		z-index: 0;

		&.semi-circle {
			top: 0;
			left: 0;
		}

		&.semi-doughnut {
			top: 8%;
			right: 0;
		}
	}

	.container {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		height: 100%;
		margin: 0 auto;
		padding: 24px;
		z-index: 1;

		.content {
			display: flex;
			flex-direction: column;
			justify-content: center;
			margin: auto;
		}

		.subtitle {
			margin-bottom: 16px;
		}

		.cards {
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
		}

		.card {
			background-color: white;
			border-radius: 4px;
			display: flex;
			flex-direction: column;
			justify-content: space-between;
			margin-bottom: 20px;
			padding: 16px;
			box-shadow: 0px 0px 16px rgba(12, 23, 119, 0.1);
			width: 100%;
			max-width: 300px;

			p,
			h2 {
				margin-bottom: 20px;
			}

			.step-number {
				text-transform: capitalize;
			}

			${Button},
			.app-store-badge {
				height: 48px;
			}

			${Button} {
				font-size: 1em;
			}
		}

		.footer {
			margin-bottom: 16px;
			display: flex;
			flex-direction: column;

			.truste-seal {
				display: block;
				margin-bottom: 16px;
			}
		}
	}

	@media (max-width: ${UiBreakpoint}px) {
		background-color: ${Colors.grey100};
	}
`;

export default InstallAppStyles;
